import { config } from "../config";
import { generateQueryString, makeApiRequest_AppJson, makeApiRequest_formData } from "./common-apiService";

export const importingCSVFile = async (file, prioritizeCSV, columnSeparator, accessToken) => {
    const formData = new FormData();
    formData.append("file", file);
    const encodedColumnSeparator = encodeURIComponent(columnSeparator);
    const url = `${config.baseB2B_URL}/b2b/language/import?prioritizeCSV=${prioritizeCSV}&columnSeparator=${encodedColumnSeparator}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const getCSVFile = async (searchFields, accessToken, fileName = 'filename.csv') => {
    const queryString = generateQueryString(searchFields);
    const url = `${config.baseB2B_URL}/b2b/language/downloadCsv${queryString ? `?${queryString}` : ''}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });
    if (!response.ok)
        throw new Error('Failed to fetch CSV file');
    const data = await response.text();
    const utf8Data = new TextEncoder().encode(data);
    const blob = new Blob([utf8Data], { type: 'text/csv; charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();
    window.URL.revokeObjectURL(link.href);
};

export const getLanguageList_Paged = async (pageNumber, pageSize, searchFields, accessToken) => {
    const queryString = generateQueryString(searchFields);
    const url = `${config.baseB2B_URL}/b2b/language/paged?page=${pageNumber}&size=${pageSize}${queryString ? `&${queryString}` : ''}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const getNotFoundLanguageList_Paged = async (pageNumber, pageSize, searchFields, accessToken) => {
    const queryString = generateQueryString(searchFields);
    const url = `${config.baseB2B_URL}/b2b/language/notFounds/paged?page=${pageNumber}&size=${pageSize}${queryString ? `&${queryString}` : ''}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const getKeyTranslations = async (key, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/language/labelTranslations?labelKey=${key}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const saveNewTranslation = async (languageTranslation, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/language/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    const body = {
        ...languageTranslation,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, body);
}

export const removeAllKeyTranslations = async (key, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/language/deleteAllTranslations?key=${key}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchGitLanguageData = async () => {
    const url = `${config.baseB2B_URL}/b2b/language/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};